import React, { useState, useEffect, useRef } from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import './NoiseTwoColumnFeatureBanner.scss';
import NoiseGIF from '../../../../assets/noise/noiseGIF.gif';
import Noise01Webp from '../../../../assets/noise/noise-01.webp';
import Noise02Webp from '../../../../assets/noise/noise-02.webp';

const TwoColumnFeatureBanner = () => {
  const sliderRef = useRef(null);
  const settings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
    arrows: true,
    autoplaySpeed: 3000,
  };

  return (
    <div className="noise-banner-section">
      <div className="noisecolumn noisefirst-panel" data-aos="fade-up">
        <h2 className="noisetitle">Ready to be yours!</h2>
        <div className="noisequestion-list" ref={sliderRef}>
          <Slider {...settings}>
            <div className="always-connected-slider-card">
              <div className="always-connected-slider-image">
                <img src={Noise01Webp} loading="lazy" />
              </div>
            </div>
            <div className="always-connected-slider-card">
              <div className="always-connected-slider-image">
                <img src={Noise02Webp} loading="lazy" />
              </div>
            </div>
          </Slider>
        </div>
      </div>
      <div className="noisecolumn noisesecond-panel" data-aos="fade-up">
        <picture>
          <source media="(max-width: 768px)" srcSet={NoiseGIF} />
          <img className="banner-image" src={NoiseGIF} alt="Banner" loading="lazy" />
        </picture>
      </div>
    </div>
  );
};

export default React.memo(TwoColumnFeatureBanner);
